export const NOYO_TRACKING_BASE_URL = 'https://app.noyo.com/tracking'

export function noyoTrackingUrl(differenceId: string): string {
  return `${NOYO_TRACKING_BASE_URL}/${differenceId}`
}

export function employeeAdminPath(employeePublicKey: string): string {
  return `/employees/${employeePublicKey}`
}
